import React from 'react';
import { Card, CardContent } from '../ui/card';
import { CheckCircle, Award, Globe, Users, ShieldCheck } from 'lucide-react';

const features = [
  {
    icon: CheckCircle,
    title: 'Premium Quality',
    description: 'Medical-grade stainless steel instruments crafted with precision and durability'
  },
  {
    icon: Award,
    title: 'ISO Certified',
    description: 'ISO 13485:2016 certified manufacturing processes ensuring consistent quality'
  },
  {
    icon: Globe,
    title: 'Global Reach',
    description: 'Exporting to 50+ countries with trusted distribution networks worldwide'
  },
  {
    icon: Users,
    title: 'Expert Team',
    description: '25+ years of surgical instrument manufacturing expertise and innovation'
  },
  {
    icon: ShieldCheck,
    title: 'Quality Assurance',
    description: 'Rigorous testing and 100% inspection before delivery'
  }
];

export const FeaturesSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Us</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by healthcare professionals for quality, reliability, and precision
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} className="border-0 hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-yellow-100 to-yellow-50 rounded-lg flex items-center justify-center mb-4 border border-yellow-200">
                    <Icon className="w-7 h-7 text-yellow-700" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
